import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Cookies from "js-cookie";
import API_ENDPOINTS from "../config/api";
import { useAuth } from "../contexts/AuthContext";

const {
  KEYS: COOKIE_KEYS,
  EXPIRES: COOKIE_EXPIRES,
  OPTIONS: COOKIE_OPTIONS,
} = API_ENDPOINTS.COOKIE_CONFIG;

// 페이지 애니메이션 변형 설정
const pageVariants = {
  initial: {
    opacity: 0,
    y: 30,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      type: "tween",
      ease: "easeOut",
      duration: 0.5,
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: {
      duration: 0.3,
    },
  },
};

function KakaoAuthPage() {
  const navigate = useNavigate();
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  useEffect(() => {
    // 쿠키에서 user_info 가져오기
    const userInfoFromCookie = Cookies.get(COOKIE_KEYS.USER_INFO);

    // if (!userInfoFromCookie) {
    //   navigate("/not-found");
    //   return;
    // }

    // 세션 스토리지에서 jointlyowned 확인 (이미 WelcomePage에서 삭제됨)
    const jointlyowned = sessionStorage.getItem("jointlyowned");
  }, [navigate]);

  const handleKakaoAuth = () => {
    // 인증 중 상태로 변경
    setIsAuthenticating(true);

    // 실제 카카오 인증 대신 5초 후 자동으로 신분증 제출 페이지로 이동
    setTimeout(() => {
      // 신분증 제출 페이지로 이동
      navigate("/id-card-submit");
    }, 5000);
  };

  return (
    <motion.div
      className="page-container"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <motion.div
        className="page-header"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.1 }}
      >
        {/* <h1>변호사 선임약정서 체결 (2/2)</h1> */}
      </motion.div>

      <div className="kakao-auth-content">
        <div className="logo-container">
          <img src="/kakao.png" alt="카카오 인증" className="main-logo" />
        </div>

        {isAuthenticating ? (
          <div className="auth-in-progress">
            <div className="loading-spinner"></div>
            <motion.h3
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              카카오 인증 요청 중...
            </motion.h3>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              잠시만 기다려주세요. 카카오톡으로 인증 메시지가 발송되었습니다.
            </motion.p>
          </div>
        ) : (
          <div className="auth-message">
            <h2>계약서 전문</h2>
            <h3>확인 동의가 완료되었습니다.</h3>
            <p>이제 카카오 인증으로 전자서명을 진행합니다.</p>
          </div>
        )}

        <div style={{ height: "100px" }}></div>
      </div>

      {!isAuthenticating && (
        <button className="kakao-auth-button" onClick={handleKakaoAuth}>
          <img src="/kakaoLogo.png" alt="카카오 로고" className="kakao-logo" />
          카카오 인증으로 동의하기
        </button>
      )}
    </motion.div>
  );
}

export default KakaoAuthPage;
